<template>
  <div class="education">
    <div class="comfirmModal" v-show="isComfirm"></div>
    <div class="box" v-show="isComfirm">
      <p class="title">提示</p>
      <p class="tips">确认{{toastTitle}}?</p>
      <div class="content">
        <span @click="isComfirm = false">取消</span>
        <a id="comfirmBtn2" target="_self" href="javascript:void(0);">确认</a>
      </div>
    </div>
    <div class="release" @click="release">发 布</div>
    <!-- <a href="#" style="display:none" id="roundBtn">111</a> -->
    <!-- 顶部导航 -->
    <mt-navbar v-model="selected">
      <mt-tab-item id="新申请">新申请</mt-tab-item>
      <mt-tab-item id="等待中">等待中</mt-tab-item>
      <mt-tab-item id="进行中">进行中</mt-tab-item>
      <mt-tab-item id="已结束">已结束</mt-tab-item>
    </mt-navbar>
    <!-- 搜索框 -->
    <div class="search-cancel">
      <input type="text" placeholder="搜索" class="input" v-model="keyword" @keyup.enter="handleKeyUp()">
      <mt-button type="primary" size="small" @click="cancel">取消</mt-button>
    </div>
    <!-- 等待中 -->
    <div v-show="selected==='等待中'" class="content-container">
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="wardRoundList.length > 0"
      >
        <div class="item" v-for="(item, index) in wardRoundList" :key="index">
          <h4>{{item.roundsTitle}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.roundsHospital}}</p>
            <p class="doctor">{{item.roundsDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.nextDate}}</p>
          </div>
          <div class="introduction">
          {{item.applyNote}}
          </div>
          <!-- 按钮组 -->
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="wardround(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '查房'">查房</mt-button>
              <mt-button @click="abolish(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '停止'">停止</mt-button>
              <mt-button @click="join(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '进入'">进入</mt-button>
            </div>
          </div>
        </div>
        <!-- 加载动画 -->
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <!-- 提示没有更多 -->
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
    <!-- 进行中 -->
    <div v-show="selected==='进行中'" class="content-container">
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="wardRoundList.length > 0"
      >
        <div class="item" v-for="(item, index) in wardRoundList" :key="index">
          <h4>{{item.roundsTitle}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.roundsHospital}}</p>
            <p class="doctor">{{item.roundsDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.firstDate}}</p>
          </div>
          <div class="introduction">
          {{item.applyNote}}
          </div>
          <!-- 按钮组 -->
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="wardround(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '查房'">查房</mt-button>
              <mt-button @click="join(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '进入'">进入</mt-button>
            </div>
          </div>
        </div>
        <!-- 加载动画 -->
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <!-- 提示没有更多 -->
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
    <!-- 新申请 -->
    <div v-show="selected==='新申请'" class="content-container">
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <!-- 内容 -->
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="wardRoundList.length > 0"
      >
        <div class="item" v-for="(item, index) in wardRoundList" :key="index">
          <h4>{{item.roundsTitle}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.roundsHospital}}</p>
            <p class="doctor">{{item.roundsDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.nextDate}}</p>
          </div>
          <div class="introduction">
          {{item.applyNote}}
          </div>
          <!-- 按钮组 -->
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="arrange(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '安排'">安排</mt-button>
              <mt-button @click="voided(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '作废'">作废</mt-button>
              <mt-button @click="edit(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '编辑'">编辑</mt-button>
            </div>
          </div>
        </div>
        <!-- 加载动画 -->
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <!-- 提示没有更多 -->
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
    <!-- 已结束 -->
    <div v-show="selected==='已结束'" class="content-container">
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <!-- 内容 -->
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="wardRoundList.length > 0"
      >
        <div class="item" v-for="(item, index) in wardRoundList" :key="index">
          <h4>{{item.roundsTitle}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.roundsHospital}}</p>
            <p class="doctor">{{item.roundsDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.firstDate}}</p>
          </div>
          <div class="introduction">
          {{item.applyNote}}
          </div>
          <!-- 按钮组 -->
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="edit(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '进入'">进入</mt-button>
            </div>
          </div>
        </div>
        <!-- 加载动画 -->
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <!-- 提示没有更多 -->
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
    <!-- 停止模态框 -->
    <div class="stopModal" v-show="isShowStopModal">
      <div class="content">
        <div>
          <mt-radio
            v-if="this.stopForm.cycle != '单次'"
            v-model="stopForm.radio"
            :options="['永久停止', '单次停止']">
          </mt-radio>
         
          <!-- <mt-radio
            v-if="this.stopForm.cycle == '单次'"
            v-model="stopForm.radio"
            :options="['永久停止']">
          </mt-radio> -->
          <p v-if="this.stopForm.radio == '永久停止'" style="color:red;font-size:14px;padding-left:10px;">注意: 将会永久停止查房</p>
          <p v-if="this.stopForm.radio == '单次停止'" style="color:red;font-size:14px;padding-left:10px;">注意: {{stopForm.nextDate}} 的查房将会被停止，你可以进行下一次的查房</p>
        </div>
        <p><mt-field v-model="stopForm.reason" label="停止理由" placeholder="请输入"></mt-field></p>
        <p>
          <mt-button type="primary" size="small" style="float:right;margin-right:20px;" @click="handleStop">确定</mt-button>
          <mt-button type="default" size="small" style="float:right;margin-right:20px;" @click="isShowStopModal = false">取消</mt-button>
        </p>
      </div>
    </div> 
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import { MessageBox } from 'mint-ui';
import moment from 'moment'
export default {
  data() {
    return {
      toastTitle: '',
      notdata: false,
      isDanci: false,
      isShowStopModal: false,
      isLoading: true,
      loadmodal: true,
      noMore: false,
      isMoreLoading: false,
      status: 1,  //课程状态
      loading: '',
      selected: '新申请',
      allLoaded: false,
      wardRoundList: [],
      pageInfo: { // 分页信息
        currentPage: 0,
        pagesize: 30,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      },
      stopForm: {
        radio: ''
      },
      keyword: '',
      isComfirm: false
    }
  },
  created() {
    localStorage.setItem("selected", "查房")
  },
  mounted() {
    this.getAllWardRound()
  },
  methods: {
    handleKeyUp() {
      this.pageInfo = { // 分页信息
        currentPage: 0,
        pagesize: 30,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
      this.getAllWardRound('', this.keyword)
    },
    cancel() {
      this.pageInfo = { // 分页信息
        currentPage: 0,
        pagesize: 30,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
      this.keyword = ''
      this.getAllWardRound()
    },
    // 点击安排按钮
    arrange(val) {
      this.$router.push({
        name: 'ArrangeRound',
        query: {
          id: val.id
        }
      })
    },
    // 点击编辑按钮
    edit(val) {
      this.$router.push({
        name: 'SubWardRound',
        query: {
          type: 'edit',
          id: val.id
        }
      })
    },
    // 点击停止按钮
    abolish(val) {
      this.stopForm = JSON.parse(JSON.stringify(val))
      this.stopForm.firstDate = moment(this.stopForm.firstDate).format('YYYY-MM-DD HH:mm')
      this.$set(this.stopForm, 'radio', '永久停止')
      this.isShowStopModal = true
    },
    // 执行停止操作
    handleStop() {
      if (this.stopForm.reason == undefined || this.stopForm.reason == '') {
        Toast({
          message: '请输入停止理由',
          position: 'top',
          duration: 1500
        });
        return
      }
      let radio
      if (this.stopForm.cycle == '单次') {
        this.stopForm.radio = '单次停止'
      }
      this.stopForm.radio == '单次停止' ? radio = 1 : radio = 2
      this.Axios.put("/api/Cooperative/CancelCooperative?id="+this.stopForm.id+"&cancelReason="+this.stopForm.reason+"&status="+parseInt(radio)).then(res=>{
        if(res.data.status == 100){
          Toast({
            message: '停止成功!',
            position: 'top',
            duration: 1500
          });
          this.pageInfo.currentPage = 0
          this.status = 2
          this.getAllWardRound()
          this.isShowStopModal = false;
        } else {
          Toast({
            message: '网络错误请联系管理员!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error=>{
        Toast({
          message: '网络错误请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 作废
    voided(val) {
      MessageBox.confirm('确定作废此申请?').then(action => {
        this.Axios.put("/api/Cooperative/DiscardCooperative?id="+val.id).then(res=>{
          if(res.data.status===100){
            Toast({
              message: '作废成功!',
              position: 'top',
              duration: 1500
            });
            this.getAllWardRound()
          } else {
            Toast({
              message: data.message,
              position: 'top',
              duration: 1500
            });
          }
        }).catch(error=>{
          Toast({
            message: error,
            position: 'top',
            duration: 1500
          });
        })
      })
    }, 
    // 查房
    wardround(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.nextDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)
      let currentDate = new Date()
      let currentStamp = Date.parse(currentDate)
      if ((dateStamp - currentStamp) > 1200000) {
        Toast({
          message: '查房时间前二十分钟才能开始查房!',
          position: 'top',
          duration: 1500
        });
      } else {
        // let btn = document.getElementById('roundBtn')
        this.Axios.get("/api/LiveCourse/RefreshStartUrl?ID="+val.id+"&type=3").then(res=>{
          if (res.data.status == 100) {
            // btn.href = res.data.startUrl
            // btn.click()
            // const deviceAgent = navigator.userAgent
            // const isIos = deviceAgent.toLowerCase().match(/(iphone|ipod|ipad)/)
            // if (isIos) {
            //   // document.location.href = res.data.startUrl
            //   btn.href = res.data.startUrl
            // } else {
            //   window.open(res.data.startUrl)
            // }
            this.toastTitle = '查房'
            // alert(222)
            this.isComfirm = true
            let comfirmBtn = document.getElementById('comfirmBtn2')
            // alert("苹果果机！")
            let url = res.data.startUrl.replace('?', '%3f')
            url = url.replace('=', '%3d')
            comfirmBtn.href = `http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`
            // window.open(`http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`)

            this.getAllWardRound()
          } else if (res.data.status == 200){
            Toast({
              message: '内部异常请联系管理员!',
              position: 'top',
              duration: 1500
            });
          } else {
            Toast({
              message: '内部异常请联系管理员!',
              position: 'top',
              duration: 1500
            });
          }
        })
      }  
    },
    // 主持
    host(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.lectureTime);
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj);
      //获取当前时间
      let currentDate = new Date();
      let currentStamp = Date.parse(currentDate);
      if (currentStamp - dateStamp > 1200000) {
        Toast({
          message: '直播前二十分钟才能开始进行!',
          position: 'top',
          duration: 1500
        });
      } else {
        // let btn = document.getElementById('roundBtn')
        this.Axios.get(
          "/api/LiveCourse/RefreshStartUrl?ID=" + val.id + "&type=1"
        ).then(res => {
          // console.log(res.data)
          const data = res.data;
          if (data.status == 100) {
            // console.log(data.startUrl)
            // window.open(data.startUrl);
            // btn.href = data.startUrl
            // btn.click()
            this.toastTitle = '主持'
            this.isComfirm = true
            let comfirmBtn = document.getElementById('comfirmBtn2')
            // alert("苹果果机！")
            let url = data.startUrl.replace('?', '%3f')
            url = url.replace('=', '%3d')
            comfirmBtn.href = `http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`
            // window.open(`http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`)
            this.getAllWardRound()
          } else if (data.status == 200) {
            Toast({
              message: '内部异常联系管理员!',
              position: 'top',
              duration: 1500
            });
          } else {
            Toast({
              message: '参数错误!',
              position: 'top',
              duration: 1500
            });
          }
        });
      }
    },
    // 进入
    join(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.lectureTime);
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj);
      //获取当前时间
      let currentDate = new Date();
      let currentStamp = Date.parse(currentDate);
      // console.log(dateStamp - currentStamp)
      if (currentStamp - dateStamp > 1200000) {
        Toast({
          message: '直播前二十分钟才能开始进行!',
          position: 'top',
          duration: 1500
        });
      } else {
        // let btn = document.getElementById('roundBtn')
        this.Axios.get("/api/LiveCourse/GetJoinUrl").then(res => {
          const data = res.data;
          if (data.status == 100) {
            let url1 = val.joinUrl + "?zpk=" + data.data;
            // window.open(url);
            // btn.href = url
            // btn.click()
            this.toastTitle = '进入'
            this.isComfirm = true
            let comfirmBtn = document.getElementById('comfirmBtn2')
            // alert("苹果果机！")
            let url = url1.replace('?', '%3f')
            url = url.replace('=', '%3d')
            comfirmBtn.href = `http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`
            // window.open(`http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`)
            this.Axios.get(
              "/api/Boardroom/JoinInfos?mid=" + val.id + "&type=3"
            ).then(res => {
              // console.log("进入", res.data);
            });
          } else if (data.status === 200) {
            Toast({
              message: '未查询到账号信息!',
              position: 'top',
              duration: 1500
            });
          }
        });
        this.getAllWardRound()
      }
    },
    // 获取所有查房信息
    getAllWardRound(type, keyword) {
      this.noMore = false
      this.notdata = false

      if (type == 'loadMore') {
        this.loadmodal = false  //顶部加载动画
        this.isLoading = true //底部的加载动画
      } else {
        this.loadmodal = true
        this.isLoading = false
        this.wardRoundList = []
      }

      if (keyword != '' && keyword != undefined) {
        var query = {
          status: this.status,
          pageindex: this.pageInfo.currentPage + 1,
          pagesize: this.pageInfo.pagesize,
          keyword: keyword
        }
      } else {
        var query = {
          status: this.status,
          pageindex: this.pageInfo.currentPage + 1,
          pagesize: this.pageInfo.pagesize
        }
      }
      this.Axios.get('/api/WeChat/GetCooperativeInfos', {
        params: query
      }).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status == 100) {
          this.loadmodal = false
          data.total == 0 ? this.notdata = true : this.notdata = false
          // 如果总条数小于每页显示数
          if (data.total < this.pageInfo.pagesize) {
            this.isLoading = false
            this.noMore = true
          }
          for (let item of data.data) {
            item.firstDate = moment(item.firstDate).format('YYYY-MM-DD HH:mm')
            item.nextDate = moment(item.nextDate).format('YYYY-MM-DD HH:mm')
          }
          if (type == 'loadMore') {
            this.wardRoundList = this.wardRoundList.concat(data.data)
          } else {
            this.wardRoundList = data.data
          }
          //总条数
          this.pageInfo.total = data.total
           //总页数
          this.pageInfo.totalPage = Math.ceil(this.pageInfo.total / this.pageInfo.pagesize)
          if (query.pageindex > this.pageInfo.totalPage) {
            this.isLoading = false
            this.noMore = true
          }
        } 
      })
    },
    loadMore() {
      this.pageInfo.currentPage += 1 // 增加分页
      this.isMoreLoading = true // 设置加载更多中
      this.isLoading = true // 底部加载动画
      this.loadMore = false //顶部加载动画
      if (this.pageInfo.currentPage > this.pageInfo.totalPage) { // 超过了分页
        this.noMore = true // 显示没有更多了
        this.isLoading = false // 关闭加载中
        return false
      }
      // 做个缓冲
      setTimeout(() => {
        this.getAllWardRound('loadMore')
      }, 100)
    },
    // 进行中
    conduct() {
      this.selected = '进行中'
      this.pageInfo.currentPage = 0
      this.status = 3
      this.getAllWardRound()
    },
    // 新申请
    ceased() {
      this.selected = '新申请'
      this.pageInfo.currentPage = 0
      this.status = 1
      this.getAllWardRound()
    },
    // 等待中
    waiting() {
      this.selected = '等待中'
      this.pageInfo.currentPage = 0
      this.status = 2
      this.getAllWardRound()
    },
    // 已结束
    ended() {
      this.selected = '已结束'
      this.pageInfo.currentPage = 0
      this.status = 6
      this.getAllWardRound()
    },
    // 点击发布按钮
    release() {
      this.$router.push({
        name: 'SubWardRound',
        query: {
          type: 'add'
        }
      })
    }
  },
  watch: {
    selected: function(val, oldVal) {
      // console.log(val)
      if (val == '进行中') {
        this.conduct()
      } else if (val == '新申请') {
        this.ceased()
      } else if (val == '等待中') {
        this.waiting()
      } else {
        this.ended()
      }
    } 
  }
}
</script>

<style lang="less">
.education {
  height: 100%;
  background: #f5f5f9;
  position: relative;
  .comfirmModal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
    z-index: 2;
  }
  .box {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    background-color: #fff;
    width: 85%;
    border-radius: 3px;
    font-size: 16px;
    -webkit-user-select: none;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: .2s;
    transition: .2s;
    // opacity: 1;
    z-index: 99;
    .title {
      text-align: center;
      font-weight: 700;
      font-size: 16px;
    }
    .tips {
      text-align: center;
      height: 36px;
      line-height: 36px;
      padding: 10px 20px 15px;
      color: rgb(153, 153, 153);
    }
    .content {
      height: 36px;
      line-height: 36px;
      border-top: 1px solid #ccc;
      span {
        cursor: pointer;
        display: inline-block;
        width: 50%;
        text-align: center;
        border-right: 1px solid #ccc;
        box-sizing: border-box;
      }
      a {
        cursor: pointer;
        display: inline-block;
        width: 50%;
        text-align: center;
        text-decoration: none;
        color: rgb(38, 162, 255)
      }
    }
  }
  .search-cancel {
    background: #f5f5f9;
    height: 32px;
    border-top: 1px solid #ccc;
    padding-left: 3%;
    padding-top: 10px;
    padding-bottom: 10px;
    overflow: hidden;
    .input {
      width: 67%;
      height: 30px;
      border: white;
      border-radius: 4px;
      text-align: center;
      outline: none;
    }
    .mint-button--small {
      height: 26px;
      margin-left: 4%;
    }
  }
  .stopModal {
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 99.9%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    // margin: auto;
    .content {
      width: 80%;
      height: 270px;
      margin: 120px auto;
      background: white;
      opacity: 1;
      position: relative;
      border-radius: 5px;
      z-index: 10;
      // border: 1px solid #7e7e7e;
      .mint-cell {
        border-radius: 5px;
      }
    }
  }
  .release {
    position: fixed;
    right: 5%;
    top: 70%;
    // top: 300px;
    z-index: 1;
    width: 20%;
    height: 50px;
    background: #66ffcc;
    text-align: center;
    line-height: 50px;
    border-radius: 10% 25%;
    color: #fff;
  }
  .mint-navbar {
    background: #f5f5f9;
    height: 48px;
  }
  .content-container {
    height: ~"calc(100% - 101px)";
    .item-wrapper {
      height: 99%;
      overflow: auto;
      .item {
        width: 92%;
        padding-left: 4%;
        padding-right: 4%;
        background: white;
        padding-top: 4%;
        padding-bottom: 1%;
        margin-bottom: 8px;
        h4 {
          margin: 0;
          margin-bottom: 15px;
        }
        .hname-doctor {
          overflow: hidden;
          font-size: 14px;
          margin-bottom: 14px;
          color: #aeaeae;
          .hospital-name {
            float: left;
            margin: 0;
          }
          .doctor {
            float: right;
            margin: 0;
          }
        }
        .introduction {
          font-size: 13px;
          margin-bottom: 14px;
          color: #aeaeae;
          line-height: 20px;
        }
        .waite-btn-wrapper {
          overflow: hidden;
          .waite-btn {
            height: 24px;
            margin-left: 2%;
            float: right;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .mint-cell {
    background-image: none !important;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
